module.exports = {"are_you_sure":"Are you sure?","cannot_undo":"You won't be able to undo this!","confirm_delete":"Yes, delete it!"};